[
  {
    "code": "MD-AN",
    "name": "Anenii Noi"
  },
  {
    "code": "MD-BA",
    "name": "Balti"
  },
  {
    "code": "MD-BS",
    "name": "Basarabeasca"
  },
  {
    "code": "MD-BD",
    "name": "Bender [Tighina]"
  },
  {
    "code": "MD-BR",
    "name": "Briceni"
  },
  {
    "code": "MD-CA",
    "name": "Cahul"
  },
  {
    "code": "MD-CT",
    "name": "Cantemir"
  },
  {
    "code": "MD-CU",
    "name": "Chișinău City"
  },
  {
    "code": "MD-CM",
    "name": "Cimișlia"
  },
  {
    "code": "MD-CR",
    "name": "Criuleni"
  },
  {
    "code": "MD-CL",
    "name": "Călărași"
  },
  {
    "code": "MD-CS",
    "name": "Căușeni"
  },
  {
    "code": "MD-DO",
    "name": "Dondușeni"
  },
  {
    "code": "MD-DR",
    "name": "Drochia"
  },
  {
    "code": "MD-DU",
    "name": "Dubasari"
  },
  {
    "code": "MD-ED",
    "name": "Edinet"
  },
  {
    "code": "MD-FL",
    "name": "Florești"
  },
  {
    "code": "MD-FA",
    "name": "Fălești"
  },
  {
    "code": "MD-GA",
    "name": "Gagauzia, Unitate Teritoriala Autonoma (UTAG)"
  },
  {
    "code": "MD-GL",
    "name": "Glodeni"
  },
  {
    "code": "MD-HI",
    "name": "Hîncești"
  },
  {
    "code": "MD-IA",
    "name": "Ialoveni"
  },
  {
    "code": "MD-LE",
    "name": "Leova"
  },
  {
    "code": "MD-NI",
    "name": "Nisporeni"
  },
  {
    "code": "MD-OC",
    "name": "Ocnița"
  },
  {
    "code": "MD-OR",
    "name": "Orhei"
  },
  {
    "code": "MD-RE",
    "name": "Rezina"
  },
  {
    "code": "MD-RI",
    "name": "Rîșcani"
  },
  {
    "code": "MD-SO",
    "name": "Soroca"
  },
  {
    "code": "MD-ST",
    "name": "Strășeni"
  },
  {
    "code": "MD-SN",
    "name": "Stînga Nistrului, unitatea teritoriala din"
  },
  {
    "code": "MD-SI",
    "name": "Sîngerei"
  },
  {
    "code": "MD-TA",
    "name": "Taraclia"
  },
  {
    "code": "MD-TE",
    "name": "Telenești"
  },
  {
    "code": "MD-UN",
    "name": "Ungheni"
  },
  {
    "code": "MD-SD",
    "name": "Șoldănești"
  },
  {
    "code": "MD-SV",
    "name": "Ștefan Vodă"
  }
]